import { Link, useMatch, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { landingPage } from 'common'
import { accessBaseUrl, clientAccessBaseUrl, useStore } from 'store'
import copy from 'copy.json'
import logo from 'assets/logo.svg'
import { adminPanelPaths, basePaths } from 'paths'

import useIsPublicPage from 'hooks/useIsPublicPage'
import useIsClientPage from 'hooks/useIsClientPage'
import useIsAdminPage from 'hooks/useIsAdminPage'

import Button from 'components/Button'
import UserPanelNavigation from 'components/UserPanelNavigation'
import { UserIcon } from 'icons/User'

import { paths } from 'paths'

export default function Header() {
  const navigate = useNavigate()
  const { currentLoginUser, currentLoginUserClientPanel } = useStore()

  const isPublicPage = useIsPublicPage()
  const isClientPage = useIsClientPage()
  const isAdminPage = useIsAdminPage()
  const isRegistrationPage = useMatch(`${paths.registration}/*`)

  return (
    <StyledHeader className="dark">
      {isPublicPage && (
        <a href={landingPage}>
          <img src={logo} alt="Logo" />
        </a>
      )}

      {isClientPage && (
        <PublicWrapper>
          <LogPanel>
            <a href={landingPage}>
              <img src={logo} alt="Logo" />
            </a>

            <User>
              <UserIcon />
              {`${currentLoginUserClientPanel?.email} (${currentLoginUserClientPanel?.business_id})`}
            </User>

            <Button
              tertiary
              small
              onClick={() => window.location.replace(`${clientAccessBaseUrl}/${paths.logout}`)}
            >
              {copy.common.button.logout}
            </Button>
          </LogPanel>

          {currentLoginUserClientPanel?.type && (
            <UserPanelNavigation clientType={currentLoginUserClientPanel.type} />
          )}
        </PublicWrapper>
      )}

      {isAdminPage && (
        <Link to={basePaths.admin_panel}>
          <img src={logo} alt="Logo" />
        </Link>
      )}

      {isAdminPage && (
        <>
          <Button small onClick={() => navigate(adminPanelPaths.registration)}>
            {copy.layout.header.registration}
          </Button>

          <Button small onClick={() => navigate(adminPanelPaths.seller.search)}>
            {copy.common.button.search}
          </Button>

          <User>
            <UserIcon />
            {currentLoginUser?.login}
          </User>

          <Button
            tertiary
            small
            onClick={() => window.location.replace(`${accessBaseUrl}/${paths.logout}`)}
          >
            {copy.common.button.logout}
          </Button>
        </>
      )}

      {isRegistrationPage && (
        <Button
          tertiary
          small
          onClick={() => (window.location.href = `${clientAccessBaseUrl}/${paths.login}`)}
        >
          {copy.common.button.login}
        </Button>
      )}
    </StyledHeader>
  )
}

const StyledHeader = styled.header`
  flex: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // TODO: Remove flex-wrap when hamburger menu is provided
  flex-wrap: wrap;
  gap: 8px;

  background-color: var(--green);
  padding: 17px max(8px, calc((100% - 1312px) / 2));

  *:first-child {
    margin-right: auto;
  }

  @media (min-width: 769px) {
    flex-wrap: nowrap;
  }
`

const User = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 60px;

  svg {
    flex: none;
  }
`

const PublicWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  *:first-child {
    margin-right: 0;
  }
`

const LogPanel = styled.div`
  flex: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  *:first-child {
    margin-right: auto;
  }
`
